import React, { useEffect, useRef } from 'react';
import './Disponibilidad.scss';
import { AnimationOnScroll } from 'react-animation-on-scroll';
import "animate.css/animate.min.css";
import 'imagemapster';
import $ from "jquery";
import { useNavigate } from "react-router-dom";
import { useTranslation } from 'react-i18next';

const Disponibilidad = () => {
  const mapRef = useRef(null);
  const navigate = useNavigate();
  const { t } = useTranslation();

  useEffect(() => {
    // Función para manejar el redimensionado del mapa
    const handleResize = () => {
      if (mapRef.current) {
        const width = window.innerWidth;
        if (width > 550) {
          $(mapRef.current).mapster('resize', width, 0, 100);
        } else {
          $(mapRef.current).mapster('resize', 600, 0, 150);
        }
      }
    };

    const initializeImageMapster = () => {
      const options = {
        fillOpacity: 0.5,
        fillColor: "EBE7E1",
        mapKey: 'name', // Busca el atributo 'name' en los <area>
        isSelectable: false,
        onClick: function (e) {
          if (e.key === "ACACIA") {
            navigate("/privada-acacia");
          } else if (e.key === "ARTEMISA") {
            navigate("/privada-artemisa");
          }
        }
      };
      $(mapRef.current).mapster(options);
      handleResize(); // Ajustar tamaño inicial
    };

    // Control de carga de imagen
    const imgElement = mapRef.current;
    if (imgElement) {
      if (imgElement.complete) {
        initializeImageMapster();
      } else {
        imgElement.addEventListener('load', initializeImageMapster);
      }
    }

    // Agregar evento de redimensionado
    window.addEventListener('resize', handleResize);

    // Timer para forzar el ajuste tras renderizado inicial
    const timer = setTimeout(() => {
      handleResize();
    }, 300);

    // Limpieza al desmontar el componente
    return () => {
      window.removeEventListener('resize', handleResize);
      if (mapRef.current) {
        $(mapRef.current).mapster('unbind');
      }
      clearTimeout(timer);
    };
  }, [navigate]);

  return (
    <div className='contenedor_disponibilidad'>
      <div className='lugares-cercanos'>
        <div className='dispo_top'>
          <AnimationOnScroll
            duration={2}
            animateOnce={true}
            animateIn='animate__fadeIn'>
            <div className='subtitulo_dispo'>
              <h2>{t('disponibilidad.title1')}</h2>
            </div>
          </AnimationOnScroll>
          <div className='texto_dispo'>
            <p>{t('disponibilidad.description')}</p>
          </div>
        </div>

        <div className='lugares_dispo'>
          <AnimationOnScroll className="height-full" duration={2} animateOnce={true} animateIn='animate__fadeIn'>
            <div className='row_lugar'>
              <img src="/assets/Iconos/dispo/svg-icon-iglesia.svg" alt={t('disponibilidad.altIglesia')} />
              <p>{t('disponibilidad.iglesia')}</p>
            </div>
          </AnimationOnScroll>
          <AnimationOnScroll className="height-full" duration={2} animateOnce={true} animateIn='animate__fadeIn'>
            <div className='row_lugar'>
              <img src="/assets/Iconos/dispo/svg-icon-plaza-comercial.svg" alt={t('disponibilidad.altPlazaComercial')} className='figure2' />
              <p>{t('disponibilidad.plazaComercial')}</p>
            </div>
          </AnimationOnScroll>
          <AnimationOnScroll className="height-full" duration={2} animateOnce={true} animateIn='animate__fadeIn'>
            <div className='row_lugar'>
              <img src="/assets/Iconos/dispo/svg-icon-plaza-armas.svg" alt={t('disponibilidad.altPlazaArmas')} />
              <p>{t('disponibilidad.plazaArmas')}</p>
            </div>
          </AnimationOnScroll>
        </div>

        <div className='lugares_dispo'>
          <AnimationOnScroll className="height-full" duration={2} animateOnce={true} animateIn='animate__fadeIn'>
            <div className='row_lugar'>
              <img src="/assets/Iconos/dispo/svg-icon-parque.svg" alt={t('disponibilidad.altParque')} className='figure2' />
              <p>{t('disponibilidad.parque')}</p>
            </div>
          </AnimationOnScroll>
          <AnimationOnScroll className="height-full" duration={2} animateOnce={true} animateIn='animate__fadeIn'>
            <div className='row_lugar'>
              <img src="/assets/Iconos/dispo/colegio.svg" alt={t('disponibilidad.altcolegio')} />
              <p>{t('disponibilidad.colegio')}</p>
            </div>
          </AnimationOnScroll>
        </div>
      </div>
      {/* <div id="masterplan" className='bottom_mapa fondoMasterplan'>
                <div className='masterplan-text'>
                    <h2>DISPONIBILIDAD</h2>
                    <p>Elige una privada:</p>
                </div>
                <span className='disclamer'>Esta imagen es representativa del proyecto, sus características pueden cambiar sin previo aviso.</span>
                <img src="/assets/Simulador/Mapeado/mappeo-privadas_WEB_07-07-23.jpg" width="2396" height="1346" border="0" alt="" useMap="#mappeo_privadas_WEB_07_07_23_Map" ref={mapRef}/>
                <map name="mappeo_privadas_WEB_07_07_23_Map">
                    <area shape="poly" alt="" coords="1765,546, 1759,548, 1742,552, 1719,559, 1692,568, 1665,579, 1641,591, 1623,604, 1618,608, 1601,618, 1575,632, 1539,650, 1495,669, 1444,686, 1385,702, 1310,587, 1181,534, 1227,514, 1233,512, 1248,505, 1271,496, 1299,485, 1330,475, 1362,464, 1392,457, 1417,452, 1462,443,
                    1468,442, 1485,440,
                    1510,436, 1539,432, 1571,428, 1600,424, 1626,421, 1644,419, 1638,420, 1628,423, 1618,428, 1611,437, 1611,438, 1613,443, 1619,449, 1630,456, 1649,463, 1756,507, 1759,508, 1765,512, 1773,517, 1779,524, 1782,531, 1778,539, 1765,546" href="#olivo"/>
                    <area name="ARTEMISA" shape="poly" alt="" coords="1385,702, 1383,702, 1377,704, 1360,708, 1333,714, 1295,722, 1249,731, 1195,740, 1133,749, 1053,767, 926,801, 799,834, 793,836, 777,841, 752,847, 720,854, 683,860, 645,864, 605,864, 567,860, 533,850, 467,773, 402,697, 525,674, 649,651, 772,628, 868,609, 964,589, 1060,570,
                    1139,548, 1145,547,
                    1159,542, 1181,534, 1310,587, 1385,702" href="#artemisa"/>
                    <area shape="poly" alt="" coords="2386,673, 2293,712, 2168,660, 2042,607, 1917,554, 1906,542, 1890,533, 1872,528, 1858,525, 1852,524, 1761,488, 1670,451, 1661,445, 1661,439, 1665,435, 1670,432, 1673,431, 1715,426, 1740,424, 1766,420, 1788,416, 1803,413, 1809,412, 1829,406, 1844,406, 1849,406, 1938,431,
                    2023,476, 2035,484,
                    2123,534, 2211,584, 2300,635, 2386,673" href="#senna"/>
                    <area shape="poly" alt="" coords="2266,724, 2231,738, 2118,793, 2004,847, 1931,883, 1857,918, 1844,925, 1737,875, 1629,825, 1521,775, 1413,725, 1467,709, 1516,693, 1557,677, 1591,663, 1616,651, 1631,643, 1637,640, 1698,599, 1738,580, 1775,567, 1806,560, 1832,557, 1852,556, 1864,556, 1869,557, 2001,612,
                    2134,668, 2266,724"
                    href="#copal"/>
                    <area name="ACACIA" shape="poly" alt="" coords="1844,925, 1840,927, 1752,970, 1664,1012, 1576,1055, 1450,1114, 1325,1173, 1199,1233, 1090,1204, 980,1176, 879,1140, 808,1081, 719,1038, 690,1020, 672,1004, 663,989, 659,980, 658,976, 667,947, 685,924, 709,906, 733,893, 756,885, 772,880, 778,879, 910,845, 1007,814,
                    1079,795, 1151,775, 1163,772,
                1182,768, 1207,764, 1233,759, 1259,755, 1281,751, 1297,749, 1302,748, 1413,725, 1521,775, 1629,825, 1737,875, 1844,925" href="#acacia"/>
                </map>
            </div> */}

      <div id="masterplan" className='bottom_mapa fondoMasterplan'>
  <div className='masterplan-text'>
    <h2>{t('disponibilidad.title2')}</h2>
    <p>{t('disponibilidad.choosePrivate')}</p>
  </div>
  <span className='disclamer'>{t('disponibilidad.disclaimer')}</span>

  {/* 1. Asegúrate de que useMap coincida con el nombre del mapa */}
  <img 
    src="/assets/Simulador/Mapeado/nuevo-mapa-n.jpg" 
    width="2396" 
    height="1346" 
    border="0" 
    alt="Masterplan" 
    useMap="#image-map" 
    ref={mapRef} 
  />

  {/* 2. Definición del nuevo mapa con los nombres para ImageMapster */}
  <map name="image-map">
          {/* AREA ARTEMISA */}
          <area 
            name="ARTEMISA" 
            target="" 
            alt="Artemisa" 
            title="Artemisa" 
            href="#artemisa" 
            coords="702,817,797,798,875,766,934,747,1013,724,1085,707,1167,696,1248,681,1290,681,1330,667,1258,574,1229,554,1199,540,1152,521,1097,531,1023,540,920,559,822,576,750,593,661,612,573,633,490,639,422,660,388,673,490,800,530,827,575,834,632,834,666,827" 
            shape="poly" 
          />
          
          {/* AREA ACACIA */}
          <area 
            name="ACACIA" 
            target="" 
            alt="Acacia" 
            title="Acacia" 
            href="#acacia" 
            coords="1148,1187,1762,893,1360,701,1053,756,922,800,780,834,674,870,640,906,634,938,642,971,678,995,716,1012,752,1033,782,1048,803,1071,833,1090,858,1107,915,1126" 
            shape="poly" 
          />
        </map>
</div>
    </div>
  );
}

export default Disponibilidad;